module.exports = __webpack_public_path__ + "static/img/1.313f283.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/1.png
// module id = PK/E
// module chunks = 0